// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import objectiveKeyResultEntity from './entities/objective-key-result.json';
import objectiveKeyResultMenu from '../pages/objective-key-result/menu.json';
import objectiveKeyResultFullForm from '../pages/objective-key-result/forms/full.json';
import objectiveKeyResultContextForm from '../pages/objective-key-result/forms/context.json';
import objectiveKeyResultMiniForm from '../pages/objective-key-result/forms/mini.json';
import objectiveKeyResultLookupForm from '../pages/objective-key-result/forms/lookup.json';
import objectiveKeyResultTableView from '../pages/objective-key-result/views/table.json';
import objectiveKeyResultCardsView from '../pages/objective-key-result/views/cards.json';
import objectiveKeyResultDashboardView from '../pages/objective-key-result/views/dashboard.json';

/** Тип запису «Ключовий результат» зі сторінками пакета: меню, форми та подання з pages/objective-key-result/. */
export const objectiveKeyResultDefinition: IRecordTypeDefinition = {
  ...objectiveKeyResultEntity,
  views: assembleViewSet({
      table: objectiveKeyResultTableView,
      cards: objectiveKeyResultCardsView,
      dashboard: objectiveKeyResultDashboardView,
  }),
  form: objectiveKeyResultFullForm,
  forms: { full: objectiveKeyResultFullForm, context: objectiveKeyResultContextForm, mini: objectiveKeyResultMiniForm, lookup: objectiveKeyResultLookupForm },
  menu: objectiveKeyResultMenu,
} as IRecordTypeDefinition;
